export enum BankIdLanguage {
  Swedish = 1,
  English = 2,
}

export class BankIdStart {
  orderRef: string;
  autoStartToken: string;
  qrCode: string;
  ui: BankIdUi;
}

export class BankIdStatus {
  orderRef: string;
  qrCode: string;
  status: BankIdOrderStatus;
  statusMessage: number;
  statusTranslation: BankIdTranslation;
  signee: BankIdSignee;
}

export enum BankIdOrderStatus {
  Unknown = 0,
  Pending = 1,
  Complete = 2,
  Failed = 3,
}

export class BankIdSignee {
  personIdentityNumber: string;
  fullName: string;
  givenName: string;
  surname: string;
}

export class BankIdTranslation {
  swe: string;
  eng: string;

  constructor(from: BankIdTranslation) {
    this.swe = from?.swe;
    this.eng = from?.eng;
  }

  public static For(translation: BankIdTranslation, language: BankIdLanguage): string {
    return language === BankIdLanguage.English ? translation.eng : translation.swe;
  }
}

export class BankIdUi {
  installUrl: string;
  appNotInstalledError: BankIdTranslation;
  buttonStartApp: BankIdTranslation;
  startInstructions: BankIdTranslation;
  whichDeviceQuestion: BankIdTranslation;

  public static readonly UnknownError = new BankIdTranslation({
    swe: 'Ett fel inträffade.',
    eng: 'An error occurred.',
  });
  public static readonly InitialStatus = new BankIdTranslation({
    swe: "Starta BankID på din mobil eller surfplatta och tryck på ''Skanna QR-kod''.",
    eng: "Start Swedish BankID on your mobile or tablet and press ''Scan QR-code''.",
  });
}
